import React from "react";
import Loading from "ui-components/loading/loading";
import { WeekSummaryTiles as WeekSummaryTilesModel } from "app/data/static-load/model";
import { ReactComponent as TotalDispatchesIcon } from "images/static-load/summary-total-dispatches.svg";
import { ReactComponent as XgsDispatchesIcon } from "images/static-load/summary-xgs-dispatches.svg";
import { ReactComponent as ExternalDispatchesIcon } from "images/static-load/summary-external-dispatches.svg";
import { ReactComponent as ExternalCostIcon } from "images/static-load/summary-external-cost.svg";
import "./weekSummaryTiles.scss";

export enum WeekSummaryTileType {
  total = "total",
  xgs = "xgs",
  external = "external",
  cost = "cost",
}

interface WeekSummaryTileProps {
  type: WeekSummaryTileType;
  isLoading: boolean;
  title: string;
  value: string;
}

const getTileIcon = (type: WeekSummaryTileType) => {
  switch (type) {
    case WeekSummaryTileType.total:
      return <TotalDispatchesIcon />;
    case WeekSummaryTileType.xgs:
      return <XgsDispatchesIcon />;
    case WeekSummaryTileType.external:
      return <ExternalDispatchesIcon />;
    case WeekSummaryTileType.cost:
      return <ExternalCostIcon />;
    default:
      return null;
  }
};

const WeekSummaryTile: React.FC<WeekSummaryTileProps> = ({ type, isLoading, title, value }) => (
  <div className="week-summary-tiles__tile">
    <div className={`week-summary-tiles__icon --type-${type}`}>
      {getTileIcon(type)}
    </div>
    <div className="week-summary-tiles__content">
      {isLoading ? (
        <Loading isLoading={true} />
      ) : (
        <div className="week-summary-tiles__value">{value}</div>
      )}
      <div className="week-summary-tiles__title">{title}</div>
    </div>
  </div>
);

export const formatDispatchCount = (value?: number): string =>
  value != null ? String(value).padStart(2, "0") : "—";

export const formatExternalCost = (value?: number | null): string =>
  value != null ? `$${Math.round(value).toLocaleString()}` : "—";

interface WeekSummaryTilesProps {
  summary?: WeekSummaryTilesModel;
  isLoading: boolean;
}

const WeekSummaryTiles: React.FC<WeekSummaryTilesProps> = ({ summary, isLoading }) => (
  <div className="week-summary-tiles">
    <WeekSummaryTile
      type={WeekSummaryTileType.total}
      isLoading={isLoading}
      title="Total Dispatches"
      value={formatDispatchCount(summary?.totalDispatches)}
    />
    <WeekSummaryTile
      type={WeekSummaryTileType.xgs}
      isLoading={isLoading}
      title="XGS Dispatches"
      value={formatDispatchCount(summary?.xgsDispatches)}
    />
    <WeekSummaryTile
      type={WeekSummaryTileType.external}
      isLoading={isLoading}
      title="External Dispatches"
      value={formatDispatchCount(summary?.externalDispatches)}
    />
    <WeekSummaryTile
      type={WeekSummaryTileType.cost}
      isLoading={isLoading}
      title="External Cost"
      value={formatExternalCost(summary?.externalCost)}
    />
  </div>
);

export default WeekSummaryTiles;
